import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/telecom/TelecomClient.tsx");
